import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import VoucherFormComments from '../../components/VoucherForm/Comment/VoucherFormComments';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import { VoucherFormRulesTitle } from '../../components/VoucherForm/Rules';
import { VoucherFormCountriesAndLines } from '../../components/VoucherForm/Rules/CountriesAndLines';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';

import styles from './add-voucher.module.scss';

const AddAccompanyingPage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Marketing',
    voucherType: 'Accompanying',
    reasonField: false,
    specificationLabel: 'Specification (required accompanying person)',
    specificationRequired: true,
  };

  const VoucherFormQuantityTemplate = {
    disabled: true,
  };

  const VoucherFormStructureTemplate = {
    prefix: 'BGL',
    length: 12,
  };

  const VoucherFormDiscountTemplate = {
    disabled: true,
    discountType: 'free_ride_marketing',
    showFreeAncillaries: true,
  };

  const VoucherFormBookingTemplate = {
    usageType: 'single',
    disableAllowedPlatforms: false,
    disableValidity: true,
  };

  const VoucherFormCountriesAndLinesTemplate = {
    allowedCountries: false,
    transportType: true,
  };

  return (
    <>
      <VoucherFormBanner title='Customer Service - Accompanying Person' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity template={VoucherFormQuantityTemplate} />
            <VoucherFormStructure template={VoucherFormStructureTemplate} />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
          </div>
          <div className={styles.container}>
            <VoucherFormRulesTitle />
            <VoucherFormCountriesAndLines template={VoucherFormCountriesAndLinesTemplate} />
          </div>
          <div className={styles.container}>
            <VoucherFormComments />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddAccompanyingPage;
